import React, { Component } from 'react';
import { Link } from "gatsby";

import { Row, Col, Form, Button, ButtonGroup, Dropdown } from 'react-bootstrap';

import Layout from '../Frame/Layout';
import { Helmet } from "react-helmet";
import favicon from '../images/favicon.ico'

import { Loader } from 'react-overlay-loader';

import Common from '../Common';
import AnalysisResult from '../Common/AnalysisResult';
import Auth from '../Common/Auth';
import PlayBehaviorModal from '../components/PlayBehavior/PlayBehaviorModal';
import JsonLd from '../Common/JsonLd';
import SLogin from '../Common/SLogin/SLogin';
import PremiumIndicator from '../Common/PremiumIndicator';
import TitleAndMore from '../Common/TitleAndMore/TitleAndMore';
import AutoScrollOption from '../Common/AutoScrollOption/AutoScrollOption';
import ExampleGen from '../Common/ExampleGen/ExampleGen';
// import Onboard from '../Common/Onboard/Onboard';

import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { window, document, exists } from 'browser-monads'

import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import 'react-overlay-loader/styles.css';


class CardSelector extends Component {
    constructor(props) {
        super(props);
        this.numberList = ["A", "K", "Q", "J", "10", "9", "8", "7", "6", "5", "4", "3", "2"]
        this.firstColNumber = ["A", "K", "Q", "J", "10", "9", "8"]

        this.SPADE = Common.SPADE
        this.HEART = Common.HEART
        this.CLOVER = Common.CLOVER
        this.DIAMOND = Common.DIAMOND
        
        this.suiteList = [this.SPADE, this.HEART, this.CLOVER, this.DIAMOND]

        this.state = {
            number: "",
            suite: "",
        }

        this.numberToggle = this.props.numberId
        this.suitToggle = this.props.toggleId
    }

    handleNumberSelect = (eventKey) => {
        this.setState({number: eventKey})
    }

    handleSuiteSelect = (eventKey) => {
        this.setState({suite: eventKey})
    }

    handleClear = () => {
        this.setState({
            number: "",
            suite: ""
        })

        this.props.handleUpdate("")
    }

    updateParentState = () => {
        if(this.state.number !== "" && this.state.suite !== "") {
            let suiteString = ""

            switch(this.state.suite) {
                case this.DIAMOND:
                    suiteString = "d"
                    break
                case this.CLOVER:
                    suiteString = "c"
                    break
                case this.HEART:
                    suiteString = "h"
                    break
                case this.SPADE:
                    suiteString = "s"
                    break
                default:
                    window.alert("Something wrong is with the suite")
            }

            let cardString = this.state.number + suiteString

            this.props.handleUpdate(cardString)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.number !== prevState.number) {
            this.updateParentState()

            if(this.state.number !== "" && this.state.suite === "") {
                if(document.getElementById(this.suitToggle) !== null) {
                    document.getElementById(this.suitToggle).click()
                } else {
                    console.error('Cannot find toggle id')
                }
            }
        }

        if(this.state.suite !== prevState.suite) {
            this.updateParentState()

            if(this.state.number === "" && this.state.suite !== "") {
                if(document.getElementById(this.numberToggle) !== null) {
                    document.getElementById(this.numberToggle).click()
                } else {
                    console.error('Cannot find number id')
                }
            }
        }

        if(this.props.value === "" && prevProps.value !== "") {
            this.setState({
                number: "",
                suite: ""
            })
        }

        if(this.props.needClearing && !prevProps.needClearing) {
            this.setState({
                number: "",
                suite: "",
            })

            this.props.handleAfterClear()
        }

        if(this.props.value !== prevProps.value && this.props.value !== "" 
            && this.state.number === "" && this.state.suite === ""
            && this.props.value !== undefined) {
            let valueLength = this.props.value.length
            let number = this.props.value.substring(0, valueLength-1).toUpperCase()
            let suite = this.props.value.charAt(valueLength-1)
            suite = this.getSuitFromChar(suite)

            this.setState({
                number: number,
                suite: suite
            })
        }
    }

    getSuitFromChar = (suitChar) => {
        let suit = ""

        switch(suitChar) {
            case "d":
                suit = this.DIAMOND
                break
            case "c":
                suit = this.CLOVER
                break
            case "h":
                suit = this.HEART
                break
            case "s":
                suit = this.SPADE
                break
            default:
                suit = ""
                break
        }

        return suit
    }

    getSuitString = (suit) => {
        let suitString = ""

        switch(suit) {
            case this.DIAMOND:
                suitString = "d"
                break
            case this.CLOVER:
                suitString = "c"
                break
            case this.HEART:
                suitString = "h"
                break
            case this.SPADE:
                suitString = "s"
                break
            default:
                suitString = ""
                break
        }

        return suitString
    }

    shouldIncludeNumber = (number) => {
        if(this.state.suite === "") {
            return true
        } else {
            let suitString = this.getSuitString(this.state.suite)
            let cardString = number + suitString

            let firstHand = this.props.parent.state.myFirstCard
            let secondHand = this.props.parent.state.mySecondCard
            let sharedCards = this.props.parent.state.communityCards

            if(Common.isCardPresent(firstHand, secondHand, sharedCards, cardString)) {
                return false
            } else {
                return true
            }
        }
    }

    shouldIncludeSuit = (suit) => {
        if(this.state.number === "") {
            return true
        } else {
            let suitString = this.getSuitString(suit)
            let cardString = this.state.number + suitString

            let firstHand = this.props.parent.state.myFirstCard
            let secondHand = this.props.parent.state.mySecondCard
            let sharedCards = this.props.parent.state.communityCards

            if(Common.isCardPresent(firstHand, secondHand, sharedCards, cardString)) {
                return false
            } else {
                return true
            }
        }
    }

    getDropdownClass = (state) => {
        let dropdownClass = "card-dropdown-unselected"

        if(state.suite === this.DIAMOND || state.suite === this.HEART) {
            dropdownClass = "card-dropdown-red"
        }

        if(state.suite === this.CLOVER || state.suite === this.SPADE) {
            dropdownClass = "card-dropdown"
        }

        return dropdownClass
    }

    render() {
        return (
            <div className="dropdowns-container">
                <ButtonGroup>
                    <Dropdown as={ButtonGroup} onSelect={this.handleNumberSelect} className="card-select">
                        <Dropdown.Toggle className={this.getDropdownClass(this.state)} id={this.numberToggle} alt={this.props.altName + " Number"}>
                            {this.state.number === "" ? 
                                (<span>No.</span>) : 
                                (<b>{this.state.number}</b>)
                            }
                        </Dropdown.Toggle>
                        <Dropdown.Menu drop="down">
                            <Row>
                                <Col xs="6">
                                    {this.numberList.map((number, i) => (
                                        (this.firstColNumber.includes(number) && 
                                            this.shouldIncludeNumber(number)) &&
                                        <Dropdown.Item eventKey={number} key={i}>
                                            {number}
                                        </Dropdown.Item>
                                    ))}
                                </Col>
                                <Col xs="6">
                                    {this.numberList.map((number, i) => (
                                        (!this.firstColNumber.includes(number) &&
                                            this.shouldIncludeNumber(number)) &&
                                        <Dropdown.Item eventKey={number} key={i}>
                                            {number}
                                        </Dropdown.Item>
                                    ))}
                                </Col>
                            </Row>
                            
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown as={ButtonGroup} onSelect={this.handleSuiteSelect} className="card-select">
                        <Dropdown.Toggle className={this.getDropdownClass(this.state)} id={this.suitToggle} alt={this.props.altName + " Suit"}>
                            {this.state.suite === "" ? 
                                (<span>Su.</span>) : 
                                (<b>{this.state.suite}</b>)
                            }
                        </Dropdown.Toggle>
                        <Dropdown.Menu drop="down">
                            { this.shouldIncludeSuit(this.suiteList[0]) && (
                                <Dropdown.Item eventKey={this.suiteList[0]}>
                                    {this.suiteList[0]}
                                </Dropdown.Item>
                            )}
                            { this.shouldIncludeSuit(this.suiteList[1]) && (
                                <Dropdown.Item eventKey={this.suiteList[1]} className="red">
                                    {this.suiteList[1]}
                                </Dropdown.Item>
                            )}
                            { this.shouldIncludeSuit(this.suiteList[2]) && (
                                <Dropdown.Item eventKey={this.suiteList[2]}>
                                    {this.suiteList[2]}
                                </Dropdown.Item>
                            )}
                            { this.shouldIncludeSuit(this.suiteList[3]) && (
                                <Dropdown.Item eventKey={this.suiteList[3]} className="red">
                                    {this.suiteList[3]}
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </ButtonGroup>
                <Button className="dropdown-clear" onClick={this.handleClear} aria-label={"Clear " + this.props.altName}>
                    <FontAwesomeIcon icon={faTimes} />
                </Button>
            </div>
        )
    }

}

class SimpleView extends Component {
    constructor(props) {
        super(props);

        this.autoScrollOptionRef = React.createRef()

        this.state = {
            typingNumPlayerTimeout: 0,
            numPlayer: "6",
            myFirstCard: "",
            mySecondCard: "",
            communityCards: ["", "", "", "", ""],
            needClearing: new Array(7).fill(false),
            myWinRate: "--",
            handRank: "--",
            opponentsWinRate: "--",
            opponentsWinningHandStatus: "",
            top5OpponentHand: [], 
            action: "--",
            minPaybackRatio: -1,
            optimalBet: {},
            analysisColorClass: "",
            isCalculating: false,
            emperorToken: null,
            needScrolling: false
        };

    }

    handleNumPlayerChange = (e) => {
        if (this.state.typingNumPlayerTimeout) {
            clearTimeout(this.state.typingNumPlayerTimeout);
        }

        let self = this;

        this.setState({
            numPlayer: e.target.value.replace(/\s/g, ''),
            typingNumPlayerTimeout: setTimeout((e) => {
                self.setState({
                    typingNumPlayerTimeout: 0
                })
            }, 1000)
        })
    }

    handleMyFirstCardChange = (cardString) => {
        let newCardString = cardString.replace(/\s/g,'')

        if((cardString!==null || cardString!==undefined) && newCardString !== this.state.myFirstCard) {
            this.setState({myFirstCard: newCardString}, () => {
                this.autoGetAnalysisFromServer()
            })
        }
    }

    handleMySecondCardChange = (cardString) => {
        let newCardString = cardString.replace(/\s/g,'')
        if((cardString!==null || cardString!==undefined) !== this.state.mySecondCard) {
            this.setState({mySecondCard: newCardString}, () => {
                this.autoGetAnalysisFromServer()
            })
        }
    }

    handleCommunityCardChange = (cardString, i) => {
        let communityCards = this.state.communityCards.slice(0)
        let newCardString = cardString.replace(/\s/g,'')

        if(newCardString !== communityCards[i]) {
            communityCards[i] = cardString.replace(/\s/g,'')
            this.setState({communityCards: communityCards}, () => {
                this.autoGetAnalysisFromServer()
            })
        }
    }

    handleAfterSelfClear = (i) => {
        let needClearing = this.state.needClearing
        needClearing[i] = false

        this.setState({needClearing: needClearing})
    }

    clearCards = () => {
        Common.removeQueryString()

        if(exists(document) && 
            this.autoScrollOptionRef.current.shouldAutoScroll()) {
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $("#num_player").offset().top
                }, 400);
            }, 150)
        }

        this.setState({
            myFirstCard: "",
            mySecondCard: "",
            communityCards: ["", "", "", "", ""],
            needClearing: new Array(7).fill(true),
            myWinRate: "--",
            opponentsWinRate: "--",
            opponentsWinningHandStatus: "",
            top5OpponentHand: [], 
            action: "--",
            minPaybackRatio: -1,
            optimalBet: {},
            analysisColorClass: "",
            needScrolling: false
        })
    }

    setToken = (token) => {
        this.setState({emperorToken: token})
    }

    checkIfNumPlayerIsReasonableAndContinue = (callback) => {
        if(Common.isNumPlayerReasonable(this.state)) {
            callback()
        } else {
            window.alert("Please ensure number of players is <= 12")
            this.clearCards();
        }
    }

    autoGetAnalysisFromServer = () => {
        if(Common.shouldAutoAnalyze(this.state.myFirstCard,
            this.state.mySecondCard, this.state.communityCards)) {
            let queryString = Common.getStateBasedUrlParams(this.state)

            if(exists(window)) {
                window.history.pushState({}, "", "?" + queryString)
            }

            this.checkIfNumPlayerIsReasonableAndContinue(() => {
                this.getAnalysisFromServer()
            })
            
        }
    }

    scrollToHandAnaysis = () => {
        if(exists(document) && 
            this.autoScrollOptionRef.current.shouldAutoScroll()) {

            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $("#hand-analysis").offset().top
                }, 300);
            }, 150)
        }
    }

    scrollToFinalAnaysis = () => {
        if(exists(document) && 
            this.autoScrollOptionRef.current.shouldAutoScroll()) {

            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: $("#final-analysis").offset().top
                }, 300);
            }, 150)
        }
    }

    getAnalysisFromServer = () => {
        Common.getAnalysisFromServer(this)
    }

    handleCalculateWinRate = () => {
        if(this.state.myFirstCard === "" || this.state.mySecondCard === "") {
            window.alert('Please fill all cards in the "My Hand" section.')
            return
        }

        let flops = this.state.communityCards.slice(0, 3)
        let isSomeFlopEmpty = flops.some((card) => card === '')
        if(isSomeFlopEmpty) {
            window.alert('Please fill in all "Flop" cards.')
            return
        }

        this.getAnalysisFromServer();
    }

    setStateByUrlParams = () => {
        if(exists(window)) {
            let urlParams = new URLSearchParams(window.location.search);
            
            let numPlayer = urlParams.get('n');
            let hands = urlParams.get('h');
            let sharedCards = urlParams.get('s');

            if(numPlayer === null) {
                numPlayer = this.state.numPlayer
            }

            let firstHand, secondHand = null

            if(hands !== null) {
                let handsList = hands.split(",")
                firstHand = handsList[0]
                secondHand = handsList[1]
            } else {
                firstHand = this.state.myFirstCard
                secondHand = this.state.mySecondCard
            }

            let sharedCardsList = null

            if(sharedCards !== null) {
                sharedCardsList = sharedCards.split(",")
                for(let i=0; i++; i<5-sharedCardsList.length) {
                    sharedCardsList.push("")
                }
            } else {
                sharedCardsList = this.state.communityCards
            }

            this.setState({
                numPlayer: numPlayer,
                myFirstCard: firstHand,
                mySecondCard: secondHand,
                communityCards: sharedCardsList
            })
        }
    }

    isRedirectedComputeBeingChanged = (curState, prevState) => {
        if(Common.isRedirectedCompute()) {
            if(curState.myFirstCard !== prevState.myFirstCard 
                && prevState.myFirstCard !== "") {
                return true
            }

            if(curState.mySecondCard !== prevState.mySecondCard 
                && prevState.mySecondCard !== "") {
                return true
            }

            let previousSharedCard = prevState.communityCards.join("")
            let currentSharedCard = curState.communityCards.join("")

            if(previousSharedCard === "") {
                return false
            } else {
                if(previousSharedCard !== currentSharedCard) {
                    return true
                }
            }
        } 
        
        return false
    }

    getAnalysisForRedirectedCompute = (prevState) => {
        let currentFirstCard = this.state.myFirstCard;
        let previousFirstCard = prevState.myFirstCard;

        if(currentFirstCard !== previousFirstCard 
            && Common.isRedirectedCompute()
            && currentFirstCard !== "") {
                Common.getAnalysisFromServer(this)
        }
    }

    generateShareText = () => {
        let url = ""

        if(exists(window)) {
            let currentUrl = window.location.href;
            url = currentUrl.replace("http://localhost:8000", "https://app.edge.poker")
        } 

        if(!url.includes("n=")) {
            return "Check out Edge.poker - a poker odds calculator & analyzer that you could use while playing online poker game"
        } else {
            let urlParams = new URLSearchParams(window.location.search);
            let postStr = "When there are " + urlParams.get("n") + " players"

            if(url.includes("s=")) {
                postStr = postStr + ", your hands are  " + 
                    this.changeCardCharToSymbol(urlParams.get("h")) + 
                    "  and the shared cards are  " + 
                    this.changeCardCharToSymbol(urlParams.get("s")) + 
                    "  , then your odds of winning is: " + stateProps.myWinRate + 
                    "%. Learn more at: \n\n"
            } else {
                postStr = postStr + " and your hands are " + 
                    this.changeCardCharToSymbol(urlParams.get("h")) + 
                    " , then your odds of winning is: " + stateProps.myWinRate + 
                    "%. Learn more at: \n\n"
            }

            return postStr
        }
    }

    componentDidMount() {
        this.setStateByUrlParams()
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log(this.state.needScrolling)

        if(this.state !== prevState) {
            // For updating number of players
            if(this.state.typingNumPlayerTimeout === 0 && prevState.typingNumPlayerTimeout !== 0) {
                this.checkIfNumPlayerIsReasonableAndContinue(() => {
                    this.autoGetAnalysisFromServer()
                })
            }

            // For scrolling
            if(this.state.needScrolling !== prevState.needScrolling && this.state.needScrolling) {
                let waitTime = 500

                if(Common.isRedirectedCompute()) {
                    waitTime = 2000
                }

                if(Common.shouldShowHandResults(this.state) 
                    && this.state.communityCards[0] === '') {
                    this.scrollToHandAnaysis();
                }

                if(Common.shouldShowFinalResults(this.state.myFirstCard, 
                    this.state.mySecondCard, this.state.communityCards)) {
                    this.scrollToFinalAnaysis();
                }

                setTimeout(() => {
                    this.setState({needScrolling: false})
                }, waitTime + 100)
            }
        }
    }

    render() {
        let description = "Edge.poker helps you calculate winning odds, analyze hand ranks, compute optimal bet sizes, and more in real-time. Let us assist you while playing Texas Hold'Em!"
        let socialMediaTitle = "Edge.Poker - Online Poker Odds Calculator, Analyzer & Helper"
        let socialMediaDescription = "Check poker winning odds, hands you could lose to and how much to bet while you play with Edge.poker!"
        let socialMediaImageUrl = "https://edge.poker/pics/edge_logo_alt_white_bg.png"

        let auth = new Auth(null);
        let token = auth.getLocalToken()
        
        return (
            <Layout>
                <Helmet>
                    <title>Online Poker Odds Calculator & Analyzer - Edge.Poker</title>
                    <meta name="description" content={description}/>
                    <script type="application/ld+json">
                        {JsonLd()}
                    </script>
                    <meta name="keywords" content="edge poker, poker odds calculator, poker helper online, poker hand analyzer, poker odds, 扑克概率， 扑克计算器，
                        ポーカーオッズ, ポーカー電卓"></meta>

                    
                    {/* <link rel="canonical" href="https://app.edge.poker" /> */}
                    <meta http-equiv="content-language" content="en-us"></meta>
                    
                    <meta name="twitter:card" content="summary"/>
                    <meta name="twitter:site" content="@EdgePokerApp"/>
                    <meta name="twitter:title" content={socialMediaTitle}/>
                    <meta name="twitter:description" content={socialMediaDescription}/>
                    <meta name="twitter:image" content={socialMediaImageUrl}/>
                
                    <meta name="og:type" content="website"/>
                    <meta name="og:title" content={socialMediaTitle}/>
                    <meta name="og:description" content={socialMediaDescription}/>
                    <meta name="og:image:secure" content={socialMediaImageUrl}/>
                    <meta name="og:url" content="https://app.edge.poker"/>  
                    <script async defer src="/sl.js" type='text/javascript'/>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <link rel="icon" href={favicon} />
                </Helmet>

                <div id="fb-root"></div>

                <Loader fullPage loading={this.state.isCalculating}/>
                <SLogin setTokenHandler={this.setToken}/>
                <Row>
                    <Col xs="0" lg="2"> </Col>
                    <Col xs="12" lg="8">
                        <PremiumIndicator/>

                        {/* <Onboard/> */}
                        <TitleAndMore/>

                        <Form onSubmit={e => { e.preventDefault(); }}>
                            <Form.Group as={Row} controlId="numPlayer">
                                <Form.Label column xs="12" id="num_player">
                                    <div># of Player</div>
                                    <div className="small-font mb-2">
                                        Total counts of all players including folded players.
                                    </div>
                                </Form.Label>
                                <Col xs="6" sm="4" md="3">
                                    <Form.Control value={this.state.numPlayer} 
                                    onChange={this.handleNumPlayerChange}/>
                                </Col>
                            </Form.Group>

                            <AutoScrollOption ref={this.autoScrollOptionRef}/>
                            <hr/>
                            <Form.Group>
                                <Form.Label>
                                    My Hand
                                </Form.Label>
                                <Row id="my-cards-row">
                                    <Col xs="12" sm="12" md="4" className="mb-3">
                                        <CardSelector value={this.state.myFirstCard} parent={this} 
                                        handleUpdate={this.handleMyFirstCardChange}
                                        needClearing={this.state.needClearing[0]}
                                        handleAfterClear={()=>this.handleAfterSelfClear(0)}
                                        numberId="hand1_num"
                                        toggleId="hand1_toggle"
                                        altName="My First Hand"/>
                                    </Col>
                                    <Col xs="12" sm="12" md="4" className="mb-3">
                                        <CardSelector value={this.state.mySecondCard} parent={this} 
                                        handleUpdate={this.handleMySecondCardChange}
                                        needClearing={this.state.needClearing[1]}
                                        handleAfterClear={()=>this.handleAfterSelfClear(1)}
                                        numberId="hand2_num"
                                        toggleId="hand2_toggle"
                                        altName="My Second Hand"/>
                                    </Col>
                                    <Col>
                                    </Col>
                                </Row>
                            </Form.Group>

                            { Common.shouldShowHandResults(this.state) &&
                                <div>
                                    <div id="hand-analysis">
                                        <hr/>
                                        <div className="p-3">
                                            <AnalysisResult state={this.state} shouldShow={true}/>
                                            <div className="text-center mt-4 mb-4">
                                                <Button className="clear-btn" onClick={this.clearCards}>
                                                    <FontAwesomeIcon icon={faTimes} className="mr-2"/>
                                                    Clear Cards
                                                </Button>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    

                                    <div className="text-center mt-4 mb-4 font-14">
                                        Add the flop to analyze further winning odds
                                    </div>
                                </div>
                            }
                            
                            <hr/>
                            
                            <Form.Group>
                                <Form.Label>
                                    <div>
                                        Shared/Community Cards
                                    </div>
                                    <div className="small-font mb-3">
                                        Leave empty when unknown
                                    </div>
                                </Form.Label>
                                <Row>
                                    <Col xs="12" sm="4" md="4" className="mb-4">
                                        <div className="small-font">Flop 1</div>
                                        <CardSelector 
                                            value={this.state.communityCards[0]} 
                                            parent={this} 
                                            handleUpdate={c => this.handleCommunityCardChange(c, 0)}
                                            needClearing={this.state.needClearing[2]}
                                            handleAfterClear={()=>this.handleAfterSelfClear(2)}
                                            numberId="flop1_num"
                                            toggleId="flop1_toggle"
                                            altName="Flop 1"/>
                                    </Col>
                                    <Col xs="12" sm="4" md="4" className="mb-4">
                                        <div className="small-font">Flop 2</div>
                                        <CardSelector 
                                            value={this.state.communityCards[1]} 
                                            parent={this} 
                                            handleUpdate={c => this.handleCommunityCardChange(c, 1)}
                                            needClearing={this.state.needClearing[3]}
                                            handleAfterClear={()=>this.handleAfterSelfClear(3)}
                                            numberId="flop2_num"
                                            toggleId="flop2_toggle"
                                            altName="Flop 2"/>
                                    </Col>
                                    <Col xs="12" sm="4" md="4" className="mb-4" id="flop-3">
                                        <div className="small-font">Flop 3</div>
                                        <CardSelector 
                                            value={this.state.communityCards[2]} 
                                            parent={this} 
                                            handleUpdate={c => this.handleCommunityCardChange(c, 2)}
                                            needClearing={this.state.needClearing[4]}
                                            handleAfterClear={()=>this.handleAfterSelfClear(4)}
                                            numberId="flop3_num"
                                            toggleId="flop3_toggle"
                                            altName="Flop 3"/>
                                    </Col>
                                    
                                </Row>
                                <Row>
                                    <Col xs="12" sm="4" md="4" className="mb-4">
                                        <div className="small-font">Turn</div>
                                        <CardSelector 
                                            value={this.state.communityCards[3]} 
                                            parent={this} 
                                            handleUpdate={c => this.handleCommunityCardChange(c, 3)}
                                            needClearing={this.state.needClearing[5]}
                                            handleAfterClear={()=>this.handleAfterSelfClear(5)}
                                            numberId="turn_num"
                                            toggleId="turn_toggle"
                                            altName="Turn"/>
                                    </Col>
                                    <Col xs="12" sm="4" md="4" className="mb-4">
                                        <div className="small-font">River</div>
                                        <CardSelector 
                                            value={this.state.communityCards[4]} 
                                            parent={this} 
                                            handleUpdate={c => this.handleCommunityCardChange(c, 4)}
                                            needClearing={this.state.needClearing[6]}
                                            handleAfterClear={()=>this.handleAfterSelfClear(6)}
                                            numberId="river_num"
                                            toggleId="river_toggle"
                                            altName="River"/>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Row>
                                <Col xs="12" className="text-center mt-3">
                                    <Button className="win-rate-button mr-3 mb-3" onClick={this.handleCalculateWinRate}>Calculate Win Rate</Button>
                                </Col>
                            </Row>

                        </Form> 

                        

                    
                        { Common.shouldShowFinalResults(this.state.myFirstCard, 
                            this.state.mySecondCard, this.state.communityCards) &&
                            
                            <div id="final-analysis" >
                                <hr/>
                                <div className="p-3">
                                    <AnalysisResult state={this.state} shouldShow={true}/>
                                    <div className="text-center mt-4 mb-4">
                                        <Button className="clear-btn" onClick={this.clearCards}>
                                            <FontAwesomeIcon icon={faTimes} className="mr-2"/>
                                            Clear Cards
                                        </Button>
                                    </div>
                                    {/* <BuyUsCoffeeAd className="mb-3 mt-3"/> */}
                                </div>
                            </div>
                        }

                        { !token && (
                            <div>
                                <hr/>
                                <ExampleGen/>
                            </div>
                        )}

                        <hr/>
                        <div className="mt-5 mb-5 text-center">
                            <Link to="/advanced" className="switch">Switch to Advanced View</Link>
                        </div>

                        { !token && (
                            <div>
                                <hr/>
                                <div className="mt-4 mb-5">
                                    <h3 className="subtitle-font text-center mb-3">
                                        What is Edge.Poker?
                                    </h3>
                                    <p>
                                        This freemium <strong>online poker odds calculator</strong> and analyzer helps you to 
                                        automatically calculate your hand's winning odds, 
                                        evaluate possible opponents hands you could lose to 
                                        and tell you how much to bet optimally. 
                                        Gain an edge by using our calculator while playing online Texas Hold'em.
                                    </p>
                                    <p>
                                        We include the following features:
                                    </p>
                                    <ol>
                                        <li>Your winning chance or equity</li>
                                        <li>Average opponent's probability of winning</li>
                                        <li>Hand Rank (based on winning odds)</li>
                                        <li>Bet, check or fold advice</li>
                                        <li>Optimal bet size</li>
                                        <li>Top 5 opponents' hands that you could lose to (after flop)</li>
                                        <li>Mobile-friendly site</li>
                                        <li>Hand-range-based analysis through our premium offering</li>
                                    </ol>
                                    <p>
                                        We estimate your winning odds by performing many game simulations.
                                        Essentially, it is a poker simulator for Texas Hold'em that analyzes and summarizes various outcomes.
                                        This is a technique called Monte Carlo simulation. This simulation
                                        helps us to also analyze the type of opponents' hands that can
                                        beat your hand when the shared cards (flop, turn and river) are supplied.
                                    </p>
                                    <p>
                                        As for the advice on how to bet, it is based on Expected Value of the return of the game.
                                        The max bet percentage is based on the so-called Kelly citerion, which
                                        provides the optimal bet size to get the maximum return in the long run.
                                        If you want to learn more, please visit our About and FAQs page.
                                    </p>
                                    <p>
                                        To learn how to use Edge.poker during a game, please visit the <Link to="/how-to-use">How-to-Use</Link> page.
                                    </p>
                                </div>
                            </div>
                        )}

                        { token && (
                            <div>
                                <hr/>
                                <PlayBehaviorModal/>
                            </div>
                        )}
                        {/* <hr/>
                        <div>
                            <Share shareText={this.generateShareText()}/>
                        </div> */}
                        <hr/>
                    </Col>
                    <Col xs="0" lg="2"> </Col>
                </Row>
            </Layout>
        );
    }
}

export default SimpleView;